import * as STANDARD_MODULE_FIELDS from "@sessionboard/sessionboard-value-types/src/constants/standard-module-field-ids";
import AccountNameFormatter from "components/Global/Table3/CellFormatters/AccountNameFormatter";
import CatalogItemFormatter from "components/Global/Table3/CellFormatters/CatalogItem";
import CheckboxCellFormatter from "components/Global/Table3/CellFormatters/Checkbox";
import ContactNameFormatter from "components/Global/Table3/CellFormatters/ContactName";
import CountriesCellFormatter from "components/Global/Table3/CellFormatters/Countries";
import CurrencyFormatter from "components/Global/Table3/CellFormatters/Currency";
import DateCellFormatter from "components/Global/Table3/CellFormatters/Date";
import DateTimeCellFormatter from "components/Global/Table3/CellFormatters/DateTime";
import FileCellFormatter from "components/Global/Table3/CellFormatters/File";
import MultipleSelectCellFormatter from "components/Global/Table3/CellFormatters/MultipleSelect";
import OrderSourceFormatter from "components/Global/Table3/CellFormatters/Source";
import OpenRecordFormatter from "components/Global/Table3/CellFormatters/OpenRecord";
import PercentFormatter from "components/Global/Table3/CellFormatters/Percent";
import TextAreaCellFormatter from "components/Global/Table3/CellFormatters/TextArea";
import TextCellFormatter from "components/Global/Table3/CellFormatters/Text";
import TimeCellFormatter from "components/Global/Table3/CellFormatters/Time";
import UserCellFormatter from "components/Global/Table3/CellFormatters/User";
import EventListFormatter from "components/Global/Table3/CellFormatters/EventList";
import AccountListFormatter from "components/Global/Table3/CellFormatters/AccountList";
import DocumentRequestFormatter from "components/Global/Table3/CellFormatters/DocumentRequest";
import PrimaryContactsFormatter from "components/Global/Table3/CellFormatters/PrimaryContacts";
import SignatureFormatter from "components/Global/Table3/CellFormatters/Signature";

export default function resolveFormatter(column) {
  if (column.type === "open-record") {
    return OpenRecordFormatter;
  } else if (column.id === STANDARD_MODULE_FIELDS.ACCOUNTS.NAME) {
    return AccountNameFormatter;
  } else if (
    column.id === STANDARD_MODULE_FIELDS.CONTACTS.FIRST_NAME ||
    column.id === STANDARD_MODULE_FIELDS.CONTACTS.LAST_NAME ||
    column.id === STANDARD_MODULE_FIELDS.MODULE.FULL_NAME
  ) {
    return ContactNameFormatter;
  } else if (column.type === "checkbox" || column.type === "boolean") {
    return CheckboxCellFormatter;
  } else if (
    column.type === "languages" ||
    column.type === "dropdown" ||
    column.type === "dependency"
  ) {
    return MultipleSelectCellFormatter;
  } else if (column.type === "date") {
    return DateCellFormatter;
  } else if (column.type === "datetime") {
    return DateTimeCellFormatter;
  } else if (column.type === "time") {
    return TimeCellFormatter;
  } else if (column.type === "user") {
    return UserCellFormatter;
  } else if (column.type === "file") {
    return FileCellFormatter;
  } else if (column.type === "countries") {
    return CountriesCellFormatter;
  } else if (column.type === "source") {
    return OrderSourceFormatter;
  } else if (column.type === "percent") {
    return PercentFormatter;
  } else if (column.type === "currency") {
    return CurrencyFormatter;
  } else if (column.type === "catalog-item") {
    return CatalogItemFormatter;
  } else if (column.type === "textarea") {
    return TextAreaCellFormatter;
  } else if (column.type === "event-list") {
    return EventListFormatter;
  } else if (column.type === "account-list") {
    return AccountListFormatter;
  } else if (column.type === "document-request") {
    return DocumentRequestFormatter;
  } else if (column.type === "primary-contacts") {
    return PrimaryContactsFormatter;
  } else if (column.type === "signature") {
    return SignatureFormatter;
  }

  return TextCellFormatter;
}
